/* ==========================================================================
  main.js
========================================================================== */

// if site-header__upper exists
if (document.querySelector('.site-header__upper')) {

  // When the user scrolls the page, execute myFunction
  window.onscroll = function() {myFunction()};

  // Get the header
  var header = document.getElementById("masthead");

  // Get the offset position of the navbar
  var sticky = header.offsetTop;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function myFunction() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }
}

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init block functions
 */
component_block_functions({
  columns:  document.querySelectorAll('.wp-block-columns.reverse-column-order-on-mobile'),
});

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

// header search button

var submit = document.querySelector('.site-header .search-form__submit');

if (submit) {
  var input = document.querySelector('.site-header .search-form__input');
  submit.setAttribute("aria-controls","#search-form-input-1");
  submit.setAttribute("aria-expanded","false");

  document.querySelector('.site-header .search-form__submit').addEventListener("click", function(event){

    var searchForm = document.querySelector('.site-header .search-form');
    var expanded = searchForm.classList.contains('expanded');

    // show input field on first click
    if(!expanded) {
      submit.setAttribute("aria-expanded","true");
      searchForm.classList.add('expanded');
      event.preventDefault();
    } else {

      if(!input.value ) {
        event.preventDefault();
        submit.setAttribute("aria-expanded","false");
        searchForm.classList.remove('expanded');
      }
    }
  });
}


// jQuery(document).on('facetwp-loaded', function() {

//   if ( FWP.facets['tuotteet_archive'] ) {

//     var current_term_name = FWP.facets['tuotteet_archive'][0];

//     // show product image by current cat
//     // console.log(current_term_name);

//     const category_images = document.querySelectorAll('.category-images');

//     if (category_images) {
//       category_images.forEach((item) => {
//         const images = item.querySelectorAll('img');

//         images.forEach((image) => {

//           if (image.getAttribute('data-cat-image') == current_term_name) {

//             images.forEach((img) => {
//               img.style.display = "none";
//             });

//             image.style.display = "block";
//           } else {

//             if (image.hasAttribute('data-cat-image')) {
//               image.style.display = "none";
//             }
//           }

//         });
//       });
//     }

//     // show current taxonomy term description based on facet selected in taxonomy-tuotekategoria
//     jQuery('.facetwp-term').removeClass('show');

//     if(current_term_name) {
//       var current_term = jQuery('.facetwp-term-' + current_term_name );
//       jQuery(current_term).addClass('show');
//     }
//   }

// });


jQuery(document).ready(function ($) {

  // loop throug all links and add download attribute if filetype is .dxf
  $('table a').each(function() {
    var link = $(this).attr('href');
    var fileType = link.split('.').pop();
    var fileName = link.split('/').pop();

    if (fileName && fileType != 'pdf') {
     $(this).attr('download', fileName);
    }
   })

  // add active class to box-grid images
  $('.box-grid__link').hover(
    function () {
      $(this).siblings('.box-grid__wrap').find('.box-grid__image').addClass('hover');
    },
    function () {
      $(this).siblings('.box-grid__wrap').find('.box-grid__image').removeClass('hover');
    }
  );

  /**
   * progressbar for slick
   * https://codepen.io/mjtweaver/pen/pEkYgQ
   */

  $('.slider-nav').on('init', function(event, slick){
    var progressBar = $('.slider-nav__progress');
    var progressBarLabel = $( '.slider-nav__label' );

    var sliderPositionLeft = this.getBoundingClientRect().left;
    var sliderPositionRight = this.getBoundingClientRect().right - sliderPositionLeft;
    var currentSlidePositionRight = $('.slider-nav__item')[0].getBoundingClientRect().right;

    var progress = ((currentSlidePositionRight - sliderPositionLeft) / sliderPositionRight) * 100;

    progressBar
    .css('background-size', progress + '% 100%')
    .attr('aria-valuenow', '1/' + slick.slideCount );

    progressBarLabel
    .text( '1/' + slick.slideCount );
  });

  $('.slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

    var progressBar = $('.slider-nav__progress');
    var progressBarLabel = $( '.slider-nav__label' );

    var sliderPositionLeft = this.getBoundingClientRect().left;
    var sliderPositionRight = this.getBoundingClientRect().right - sliderPositionLeft;
    var currentSlidePositionLeft = $('.slider-nav__item')[nextSlide].getBoundingClientRect().right - sliderPositionLeft;

    console.log( $('.slider-nav__item')[nextSlide].getBoundingClientRect() );

    var progress = (currentSlidePositionLeft / sliderPositionRight) * 100;

    progressBar
      .css('background-size', progress + '% 100%')
      .attr('aria-valuenow', nextSlide + 1 + '/' + slick.slideCount );

    progressBarLabel.text( nextSlide + 1 + '/' + slick.slideCount );

  });


  var rotate = 0;

  $('.image-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

    // sync content-slider with image-slider
    $('.content-slider').slick('slickGoTo', nextSlide);

    // rotate image-slider background
    var slideCount = slick.slideCount;
    var rotateSegment = 360 / slideCount;
    var direction;

    if (Math.abs(nextSlide - currentSlide) == 1) {
      direction = (nextSlide - currentSlide > 0) ? "right" : "left";
    }
    else {
      direction = (nextSlide - currentSlide > 0) ? "left" : "right";
    }

    // rotate depending on direction
    if ( direction == 'left' ) {
      rotate = rotate - rotateSegment;
    }

    if ( direction == 'right' ) {
      rotate = rotate + rotateSegment;
    }

    // first slide
    if( nextSlide == 0 ) {
      rotate = 0;
    }

    $('.image-slider__background-container img').css('transform', 'rotate(' + rotate + 'deg)');
  });

  /**
   * keep slider intact after resize
   * https://stackoverflow.com/questions/45939631/slick-slider-not-being-responsive-when-resizing-the-window?rq=1
   */
  $(window).on('resize orientationchange', function() {
    $('.slider-nav').slick('setPosition');
  });

  /**
   * Init Slick carousel
   */
  $('.slider-for').slick({
    fade: true,
    arrows: true,
    dots: false,
    asNavFor: '.slider-nav',
    draggable: false,
    swipe: false,
    touchMove: false,
    prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><span class='arrow-prev'></span></button>",
    nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><span class='arrow-next'></span></button>",
  });

  $('.slider-nav').slick({
    asNavFor: '.slider-for',
    centerMode: true,
    arrows: false,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    draggable: false,
    swipe: false,
    touchMove: false,
    variableWidth: true
  });

  $('.single-product-slider').slick({
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><span class='arrow-prev'></span></button>",
    nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><span class='arrow-next'></span></button>",
  });

  $('.image-carousel__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.image-carousel__nav',
    prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><span class='arrow-prev'></span></button>",
    nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><span class='arrow-next'></span></button>",
  });

  $('.image-carousel__nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.image-carousel__slider',
    dots: false,
    arrows: false,
    // centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.box-grid-slider').slick({
    arrows: true,
    infinite: false,
    prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><span class='arrow-prev'></span></button>",
    nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><span class='arrow-next'></span></button>",
    dots: false,
  });

  $('.block-slider__inner').slick({
    arrows: true,
    infinite: false,
    prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><span class='arrow-prev'></span></button>",
    nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><span class='arrow-next'></span></button>",
    dots: false,
  });

  (function( $ ) {

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            styles      : [ { "featureType": "landscape", "stylers": [ { "color": "#D7F3F2" } ] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [ { "color": "#FFFFFF" } ] }, { "featureType": "road", "stylers": [ { "color": "#9ED3D1" } ] }, { "featureType": "road", "elementType": "labels", "stylers": [ { "weight": 1 } ] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "labels.text", "stylers": [ { "color": "#FFFFFF" } ] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [ { "color": "#5D5D5E" } ] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "color": "#D7F3F2" } ] }, { "featureType": "road.arterial", "elementType": "labels.text.stroke", "stylers": [ { "color": "#D7F3F2" }, { "weight": 3 } ] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [ { "color": "#5D5E5D" } ] }, { "featureType": "road.local", "elementType": "labels.text.stroke", "stylers": [ { "color": "#D7F3F2" }, { "weight": 3 } ] }, { "featureType": "water", "stylers": [ { "color": "#0090A3" } ] } ],
            mapTypeId   : google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    // Render maps on page load.
    $(document).ready(function(){
        $('.acf-map').each(function(){
            var map = initMap( $(this) );
        });
    });

    })(jQuery);


});


document.addEventListener("DOMContentLoaded", (event) => {
  initializeSliders();
});

function initializeSliders() {
  jQuery(function() {
    jQuery('.slider__for').each(function(key, item) {
      var sliderIdName = 'slider' + key;
      var sliderNavIdName = 'sliderNav' + key;

      this.id = sliderIdName;
      jQuery('.slider__nav')[key].id = sliderNavIdName;

      var sliderId = '#' + sliderIdName;
      var sliderNavId = '#' + sliderNavIdName;

      jQuery(sliderId).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        slide: 'div',
        infinite: false,
        prevArrow: jQuery(sliderId + ' .slick-prev'),
        nextArrow: jQuery(sliderId + ' .slick-next'),
        asNavFor: sliderNavId,
      });

      jQuery(sliderNavId).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        //centerMode: true,
        infinite: false,
        asNavFor: sliderId,
      });
    });
  });
}

// animate keynumber group
document.addEventListener("DOMContentLoaded", (event) => {

  const element = document.querySelector('.animate-keynumber');

  // Check if the element exists
  if (!element) {
    console.log('Element with class .animate-keynumber not found');
    return;
  }

  const parentElement = element.closest('.is-style-keynumber');
  const targetNumber = parseFloat(element.innerText.replace(',', '.'));
  let currentNumber = 0;
  const increment = targetNumber / 200; // Adjust this value to control the speed of the animation

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const intervalId = setInterval(() => {
          currentNumber += increment;
          element.classList.add('show');
          if (currentNumber >= targetNumber) {
            currentNumber = targetNumber;
            clearInterval(intervalId);
          }
          element.innerText = `${currentNumber.toFixed(1).replace('.', ',')} %`;
        }, 10); // Adjust this value to control the frequency of the animation
        observer.unobserve(parentElement);
      }
    });
  }, {
    root: null, // viewport
    rootMargin: '0px',
    threshold: 1.0 // start when 100% of the parent element is visible
  });

  observer.observe(parentElement);
});
